import {
  SET_MERCHANT_ORDER,
  SET_MERCHANT_SHOPS,
  SET_MERCHANT_DINE,
  SET_MERCHANT_UNWIND,
  SET_MERCHANT_POPULAR,
  SET_MERCHANT_MODAL_DATA,
  SET_MERCHANT_MODAL_STATUS,
  SET_DISPLAY_MALL_WELCOME,
  SET_DISPLAY_APP_BANNER,
  SET_DISPLAY_APP_MODAL,
  SET_SELECTED_MALL_SLUG,
  SET_ZING_PARTNERS,
} from './types'

function setMerchantOrder(orderShop) {
  return {
    type: SET_MERCHANT_ORDER,
    payload: {
      orderShop,
    },
  }
}
function setMerchantShop(shop) {
  return {
    type: SET_MERCHANT_SHOPS,
    payload: {
      shop,
    },
  }
}

function setMerchantDine(dine) {
  return {
    type: SET_MERCHANT_DINE,
    payload: {
      dine,
    },
  }
}

function setMerchantUnwind(unwind) {
  return {
    type: SET_MERCHANT_UNWIND,
    payload: {
      unwind,
    },
  }
}

function setMerchantPopular(popular) {
  return {
    type: SET_MERCHANT_POPULAR,
    payload: {
      popular,
    },
  }
}

function setMerchantModalData(merchantModalData) {
  return {
    type: SET_MERCHANT_MODAL_DATA,
    payload: {
      merchantModalData,
    },
  }
}

function setMerchantModalStatus(merchantModalStatus) {
  return {
    type: SET_MERCHANT_MODAL_STATUS,
    payload: {
      merchantModalStatus,
    },
  }
}

function setDisplayMallWelcome(displayMallWelcome) {
  return {
    type: SET_DISPLAY_MALL_WELCOME,
    payload: {
      displayMallWelcome,
    },
  }
}
function setDisplayAppBanner(displayAppBanner) {
  return {
    type: SET_DISPLAY_APP_BANNER,
    payload: {
      displayAppBanner,
    },
  }
}

function setDisplayAppModal(displayAppModal) {
  return {
    type: SET_DISPLAY_APP_MODAL,
    payload: {
      displayAppModal,
    },
  }
}

function setSelectedMallSlug(selectedMallSlug) {
  return {
    type: SET_SELECTED_MALL_SLUG,
    payload: {
      selectedMallSlug,
    },
  }
}

const setZingPartners = zingPartners => ({
  type: SET_ZING_PARTNERS,
  payload: {
    zingPartners,
  },
})

export {
  setMerchantOrder,
  setMerchantShop,
  setMerchantDine,
  setMerchantUnwind,
  setMerchantPopular,
  setMerchantModalData,
  setMerchantModalStatus,
  setDisplayMallWelcome,
  setDisplayAppBanner,
  setDisplayAppModal,
  setSelectedMallSlug,
  setZingPartners,
}
